'use client';
import { createContext, useContext, useEffect } from 'react';
import { useNonNullishContext } from '../../hooks/use-non-nullish-context.js';

const FormFieldContext = createContext(null);
FormFieldContext.displayName = 'FormFieldContext';
const useFormFieldContext = ()=>useContext(FormFieldContext);
const useNonNullishFormFieldContext = ()=>useNonNullishContext(FormFieldContext);
function useFormFieldProps(e) {
    let o = useFormFieldContext();
    if (useEffect(()=>{
        if (o) {
            let { setInputId: r } = o;
            return r(e), ()=>r(void 0);
        }
        return ()=>{};
    }, [
        o,
        e
    ]), null == o) return {
        id: e
    };
    let { errorIds: t, helperIds: i } = o;
    return {
        id: e,
        'aria-invalid': t.size > 0,
        'aria-errormessage': t.size > 0 ? [
            ...t
        ].join(' ') : void 0,
        'aria-describedby': t.size + i.size > 0 ? [
            ...i,
            ...t
        ].join(' ') : void 0
    };
}

export { FormFieldContext, useFormFieldContext, useFormFieldProps, useNonNullishFormFieldContext };
